import * as React from "react"

import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"
import { CellType, RowContentCell } from "@tenforce/toolbox-table-react"

import LoadMore from "../LoadMore"
import { INavigationSmartlistGroup } from "../../index"

interface Props {
    group: INavigationSmartlistGroup
    loadMoreLabel: string
    onLoadMore: () => void
    onNavigate: () => void
}

export default class SmartlistChildren extends React.PureComponent<Props> {
    render(): JSX.Element {
        const {
            group: { hasMore, smartlists },
            loadMoreLabel,
            onLoadMore,
            onNavigate,
        } = this.props

        return (
            <>
                {smartlists.map((smartlist, index) => (
                    <RowContentCell
                        key={index}
                        cellProps={{ type: CellType.action }}
                    >
                        <ActionAnchor
                            href={smartlist.url}
                            title={`${smartlist.label}/${smartlist.text}`}
                            onClick={onNavigate}
                            actionType={ActionType.block}
                            data-ft-component="smartlistChildLink"
                            data-ft-smartlist={smartlist.text.toLowerCase()}
                            extraClasses="text-black tw-px-3"
                        >
                            <div className="tw-flex-row-center tw-truncate">
                                <div className="label max-w-truncate is-limited is-dimmed">
                                    {smartlist.label}
                                </div>
                                <div className="tw-mx-1 is-dimmed">/</div>
                                <div className="tw-truncate">
                                    {smartlist.text}
                                </div>
                            </div>
                        </ActionAnchor>
                    </RowContentCell>
                ))}
                {hasMore && (
                    <LoadMore
                        loadMoreLabel={loadMoreLabel}
                        loadMore={onLoadMore}
                        data-ft-load-more="navigationSmartlistChildren"
                    />
                )}
            </>
        )
    }
}
